import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Grid } from '@mui/material';
import { Button, Card, Form, FormControlLabel, Stack, Switch, TextField } from '@curves/ui-base';

import { useCustomerResourceContext } from '@Local/CustomerResource/Components/CustomerResourceContext';
import useCustomerResourceApi from '@Apis/useCustomerResourceApi';
import { isEmpty, objectToQueryString } from '@Util/utils';
import { useHistory } from 'react-router-dom';
import { CUSTOMER_RESOURCE_OVERVIEW_ROUTER } from '@Router/routerPath';
const CustomerResourceSearchBar = (props) => {
    const { className } = props;
    const history = useHistory();
    const { setSourceData, customerResourceType, bookmark, setBookmarkNum, setRefresh } = useCustomerResourceContext();
    const { getCustomerResourceOverviewApi } = useCustomerResourceApi();
    const filterRef = useRef(null);
    const includeInactiveRef = useRef(null);
    const getParams = () => {
        const result = { ...bookmark, resourceType: customerResourceType };
        // 搜尋關鍵字
        if (filterRef.current && filterRef.current.getResult) {
            const filterValue = filterRef.current.getResult();
            if (filterValue && filterValue.trim()) {
                Object.assign(result, { 
                    search: filterValue.trim()
                });
            }
        }
        const includeInactiveEl = includeInactiveRef.current;
        if (includeInactiveEl) {
            const includeInactiveValue = includeInactiveEl.checked;
            // isEnable 的含義與 includeInactive 相反：
            const isEnableValue = !includeInactiveValue;
            Object.assign(result, { 
                isEnable: isEnableValue
            });
        } else {
            // 如果 Switch 元素不存在，設置默認值為 true（只顯示啟用的項目）
            Object.assign(result, { 
                isEnable: true
            });
        }
        return result;
    };
    /** 更新網址上的搜尋條件 **/
    const updateUrlWithSearchQuery = (params) => {
        let url = CUSTOMER_RESOURCE_OVERVIEW_ROUTER;
        if (!isEmpty(params)) url += objectToQueryString(params);
        history.replace(url);
    };
    const handleCustomerResourceOverviewApi = async (params) => {      
            let resp = await getCustomerResourceOverviewApi(params);
            if (resp && resp.success && resp.result) {
                const newData = {
                    list: resp.result.list || [],
                    pageIndex: resp.result.pageIndex || 1,
                    totalPage: resp.result.totalPage || 1,
                    totalCount: resp.result.totalCount || 0
                };
                setSourceData(newData);
                if (resp.result.pageIndex) {
                    setBookmarkNum(resp.result.pageIndex);
                }
            } else if (resp && resp.list && Array.isArray(resp.list)) {
                const newData = {
                    list: resp.list || [],
                    pageIndex: resp.pageIndex || 1,
                    totalPage: resp.totalPage || 1,
                    totalCount: resp.totalCount || 0
                };
                setSourceData(newData);
                if (resp.pageIndex) {
                    setBookmarkNum(resp.pageIndex);
                }
            } 
            updateUrlWithSearchQuery(params);       
    };
    const handleSubmitForm = () => {
        const params = getParams();
        handleCustomerResourceOverviewApi(params);
        setBookmarkNum(1);
    };
    useEffect(
        () => {
            const params = getParams();
            handleCustomerResourceOverviewApi(params);
        },
        // eslint-disable-next-line
        [bookmark.pageIndex, customerResourceType],
    );
    useEffect(() => {
        setRefresh(handleSubmitForm);
        // eslint-disable-next-line
    }, []);
    return (
        <Card className={clsx('search-bar', className)}>
            <Card.CardContent className={'px-4 py-3'}>
                <Form onSubmit={handleSubmitForm}>
                    <Grid className={className} container spacing={3}>
                        <Grid item xs={6}>
                            <TextField 
                                ref={filterRef} 
                                InputProps={{ placeholder: '搜尋項目名稱或項目編號' }} 
                                fullWidth 
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Stack className={'flex-auto'} spacing={3}>
                                <FormControlLabel 
                                    control={
                                        <Switch 
                                            inputRef={includeInactiveRef}
                                            defaultChecked={false}
                                        />
                                    } 
                                    prefixLabel={'包含未生效項目'} 
                                />
                                <Stack direction="row" spacing={2}>
                                    <Button type={'submit'} variant={'contained'} color="primary">
                                        搜尋
                                    </Button>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>
                </Form>
            </Card.CardContent>
        </Card>
    );
};
export default CustomerResourceSearchBar;
